import {
  CLIENT_CREATION_KEY_OPENAI,
  registerClientCreation,
} from "./clientRegister";
import axios, { AxiosInstance } from "axios";

// eslint-disable-next-line import/no-mutable-exports
export let openAIClient: AxiosInstance;

const create = (baseURL: string) => {
  openAIClient = axios.create({
    baseURL: baseURL + "/open-ai/",
  });

  // The API only forwards /open-ai calls for an authenticated admin, creator or collaborator.
  openAIClient.interceptors.request.use(
    async (config) => {
      const value = localStorage.getItem("authStore");

      let keys;

      if (value) {
        keys = JSON.parse(value);

        // eslint-disable-next-line no-param-reassign
        config.headers = {
          authorization: `AuthToken token=${keys.state.authConfig.authtoken}`,
        };
      }

      return config;
    },
    (error) => {
      Promise.reject(error);
    }
  );
};

registerClientCreation(CLIENT_CREATION_KEY_OPENAI, create);
